// Vendors
import $ from 'jquery';
import { Power0, Power1, TimelineMax, TweenMax } from 'gsap/all';

// Expose GSAP and legacy names to global scope
// TODO: need to find a way to support existing SVG animations without importing legacy modules
window.Power0 = Power0;
window.Power1 = Power1;
window.TimelineMax = TimelineMax;
window.TweenMax = TweenMax;

/* 'NEWS' page-builder component
   ----------------------------- */

// Only run this once, first time this event happens.
$(document).one('facetwp-refresh', () => {
  const $fwpContainer = $('.facetwp-template');
  const dateFrom = $fwpContainer.data('fwp-date-from');
  const dateTo = $fwpContainer.data('fwp-date-to');
  const facetValue = ['', ''];

  if (!dateFrom && !dateTo) {
    return;
  }

  if (dateFrom) {
    facetValue[0] = dateFrom;
  }

  if (dateTo) {
    facetValue[1] = dateTo;
  }

  FWP.facets['date_range'] = facetValue;
  FWP.fetchData();
});

// Custom evt created in js/site/vendor-facetwp.js, only run this once.
$(document).one('facetWPUpdated', () =>
  $('.fwp-wrapper.u--display-none').removeClass('u--display-none')
);

// If on last page of results, show 'Load All' button container.
$(document).on('facetwp-loaded', () => {
  const { pager } = FWP.settings;
  const { page, total_pages } = pager;

  if (page === total_pages) {
    $('.fwp-load-all__wrapper.u--display-none').removeClass('u--display-none');
  }

  // weird FWP bugfix
  if (page && total_pages == 0) {
    FWP.facets['pager'] = [];
    FWP.fetchData();
  }
});

// 'Load All' button click: reset date_rage facet..
$(document).one('click', '.fwp-load-all', (event) => {
  event.preventDefault();

  FWP.facets['date_range'] = [];
  FWP.fetchData();
  $('.fwp-load-all__wrapper').remove();
});

// About the Farm Incentive Program page
const fipLoginButton = $('[data="fip-login-button"]');

if (fipLoginButton.length) {
  const btnText = $('[data=fip-login-button] span span');

  if (window.userLoggedIn.loggedIn && window.userLoggedIn.isFip || window.userLoggedIn.isAdmin) {
    fipLoginButton.removeClass('u--display-none');
    btnText.text('Proceed To Dashboard');
    $('[data="fip-apply-now"]').hide();
  }
  
  if (!window.userLoggedIn.loggedIn) {
    fipLoginButton.removeClass('u--display-none');
  }
}

//---------------------------------------
// Equipment Directory Component Logic
//---------------------------------------

$('.manu__index-title').on('click', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  $(this).next('.manu__index-cards').toggleClass('show');
});

// Callout - Reference Guide Component Logic
//---------------------------------------

$('.callout__reference-guide-title').on('click', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  $(this).next('.callout__reference-guide-grid').toggleClass('show');
});
